import React, { useEffect } from 'react';
import useEventBus from 'hooks/useEventBus';
import * as Styles from './style';
import { Chart_ALI } from './components/Chart_ALI';
import { Chart_Evaluation } from './components/Chart_Evaluation';
import { Chart_Ropa } from './components/Chart_Ropa';
import { Chart_ThirdPartyEvaluation } from './components/Chart_ThirdPartyEvaluation';

export const Dashboard: React.FC = () => {
  const eventBus = useEventBus();
  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', 'Dashboard');
    return () => {
      eventBus.dispatchEvent('onChangeTitle', '');
    };
  }, []);

  return (
    <Styles.Container>
      <Chart_Evaluation />
      <Chart_ALI />
      <Chart_ThirdPartyEvaluation />
      <Chart_Ropa />
    </Styles.Container>
  );
};
